app.service("ConfirmModal", ["$uibModal", function ($uibModal) {
    return {
        show: function (passedData) {
            var message = passedData.message || null;
            var html = passedData.html || null;
            var title = passedData.title || false;
            var size = passedData.size || "sm";

            return $uibModal.open({
                animation: true,
                templateUrl: _pb + 'components/confirm-modal/confirm-modal.html',
                controller: ["$scope", "passedObject", "$uibModalInstance",
                    function ($scope, passedObject, $uibModalInstance) {
                        $scope.message = passedObject.message;
                        $scope.html = passedObject.html;
                        $scope.title = passedObject.title;
                        $scope.confirm = function () {
                            $uibModalInstance.close();
                        };

                        $scope.dismiss = function() {
                            $uibModalInstance.dismiss();
                        }
                    }
                ],
                size: size,
                backdrop: 'static',
                resolve: {
                    passedObject: function () {
                        return {message: message, title: title, html: html};
                    }
                }
            });
        }
    };
}]);
